import { trigger, transition, style, query, animate, group, animateChild } from '@angular/animations';

const timing = '350ms cubic-bezier(0.35, 0, 0.25, 1)';

const resetRoute = [
  style({ position: 'relative', overflow: 'hidden' }), // Evita scrollbars fantasma
  query(':enter, :leave', [
    style({
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      willChange: 'transform, opacity' // Pista para el navegador
    })
  ], { optional: true })
];

export const slideInAnimation = trigger('routeAnimations', [
  // AVANZAR (Hacia la derecha)
  transition(':increment', [
    ...resetRoute,
    // La que entra empieza a la derecha, la que sale está en el centro
    query(':enter', [style({ transform: 'translateX(100%)', opacity: 0 })], { optional: true }),

    group([
      // La que sale se desplaza solo un poco a la izquierda (Paralaje)
      query(':leave', [
        animate(timing, style({ transform: 'translateX(-30%)', opacity: 0 }))
      ], { optional: true }),

      // La que entra llega al centro
      query(':enter', [
        animate(timing, style({ transform: 'translateX(0%)', opacity: 1 }))
      ], { optional: true }),
    ]),
  ]),

  // VOLVER (Hacia la izquierda)
  transition(':decrement', [
    ...resetRoute,
    // La que entra empieza un poco a la izquierda (Paralaje invertido)
    query(':enter', [style({ transform: 'translateX(-30%)', opacity: 0 })], { optional: true }),

    group([
      // La que sale se va totalmente a la derecha
      query(':leave', [
        animate(timing, style({ transform: 'translateX(100%)', opacity: 0 }))
      ], { optional: true }),

      // La que entra vuelve al centro
      query(':enter', [
        animate(timing, style({ transform: 'translateX(0%)', opacity: 1 }))
      ], { optional: true }),
    ]),
  ])
]);
